import { Component, EventEmitter, Output } from '@angular/core'
import { Illustration, IllustrationComponent } from '@ftr/foundation'

@Component({
  standalone: true,
  selector: 'ftr-complex-list-error',
  templateUrl: './complex-list-error.component.html',
  styleUrls: ['./complex-list-error.component.css'],
  imports: [IllustrationComponent],
})
export class ComplexListErrorComponent {
  @Output() refreshed = new EventEmitter<void>()

  readonly illustration = Illustration
}
